enum NavigationActionType {
  OPEN_CONNECTOR_MODAL,
  CLOSE_CONNECTOR_MODAL,
}

export default NavigationActionType;
